export const drawerWidth = 300;
export const copyrightHeight = 18;
export const toolbarHeight = 47;
